import React from 'react';
import { styled, ButtonSecondary, Avatar } from '@creditas-ui/react';
import { clearTokens } from '@creditas-lab/auth-sdk';
import { Menu, MenuBrand, MenuList, MenuItem, SubMenu } from '@/components/Menu';
import { Close } from '@/assets/icons/Close';
import { MenuMobile } from '@/assets/icons/MenuMobile';
import { redirectToWebsite } from '@/utils/redirect';
import { dispatchLogoutEvent } from '@/utils/analyticsEvents';
import i18n from '@/i18n';
import { DownloadApps } from './DownloadApps';
import { HeaderLinks } from './HeaderLinks';

type HeaderMobileProps = {
  label: string;
};

const Button = styled(ButtonSecondary)`
  padding: 0;
`;

const HeaderMobile = ({ label }: HeaderMobileProps): JSX.Element => {
  const [openSubMenu, setOpenSubMenu] = React.useState<boolean>(false);
  return (
    <>
      <Menu>
        {openSubMenu ? (
          <Button
            aria-label="Close"
            onClick={(): void => setOpenSubMenu(false)}
            data-testid="close-menu-button"
          >
            <Close />
          </Button>
        ) : (
          <Button
            aria-label="Open"
            onClick={(): void => setOpenSubMenu(true)}
            data-testid="open-menu-button"
          >
            <MenuMobile />
          </Button>
        )}

        <MenuBrand />
        {label && <Avatar name={label} />}
      </Menu>

      {openSubMenu && (
        <SubMenu>
          <MenuList>
            <HeaderLinks>
              <MenuItem
                onClick={(): void => {
                  clearTokens();
                  dispatchLogoutEvent();
                  redirectToWebsite();
                }}
              >
                {i18n.t('header:logout')}
              </MenuItem>
            </HeaderLinks>
          </MenuList>

          <DownloadApps />
        </SubMenu>
      )}
    </>
  );
};

export { HeaderMobile };
